<div class="projects-page page">
    <main class="projects-page__content content">

        <header class="projects-page__header">
            <div class="page-title">Projects</div>
            <div class="page-subtitle">Here you manage and create ECHO projects</div>
        </header>

        <section class="projects-page__section-content">
            <div class="flex-horizontal dds-mb-3">
                <div class="projects-page__section-title">Your Projects</div>
                <dds-button [theme]="createButtonOptions.theme" [kind]="createButtonOptions.kind"
                    [size]="createButtonOptions.size" [width]="createButtonOptions.width"
                    [icon]="createButtonOptions.icon" [isIconLeft]="createButtonOptions.isIconLeft"
                    [role]="createButtonOptions.role" [isInverse]="createButtonOptions.isInverse"
                    [isColorBg]="createButtonOptions.isColorBg" [isLoading]="createButtonOptions.isLoading"
                    [ariaLabel]="createButtonOptions.ariaLabel" [customClass]="createButtonOptions.customClass"
                    (clicked)="createProjectClick($event)">Create
                    project</dds-button>
            </div>

            @if (!hasProjects) {
            <p>Nothing here yet. Create your first project!</p>
            }
            @else {
            <div class="cards-wrapper">
                @for (project of projects; track project) {
                <dds-card [isSelectable]="cardOptions.isSelectable" [isVertical]="cardOptions.isVertical"
                    [isUnbordered]="cardOptions.isUnbordered" [customClass]="cardOptions.customClass"
                    [isInverse]="cardOptions.isInverse" [isWrapFocusDisabled]="cardOptions.isWrapFocusDisabled"
                    [size]="cardOptions.size">

                    <div class="flex-horizontal">
                        <div>
                            <h5 class="dds-card__title">{{project.name}}</h5>
                            <p class="dds-card__text">{{project.description}}
                            </p>
                        </div>
                        <dds-button [theme]="viewButtonOptions.theme" [kind]="viewButtonOptions.kind"
                            [size]="viewButtonOptions.size" [width]="viewButtonOptions.width"
                            [icon]="viewButtonOptions.icon" [isIconLeft]="viewButtonOptions.isIconLeft"
                            [role]="viewButtonOptions.role" [isInverse]="viewButtonOptions.isInverse"
                            [isColorBg]="viewButtonOptions.isColorBg" [isLoading]="viewButtonOptions.isLoading"
                            [ariaLabel]="viewButtonOptions.ariaLabel" [customClass]="viewButtonOptions.customClass"
                            (clicked)="viewProjectClick(project.id)">View</dds-button>
                    </div>

                </dds-card>
                }
            </div>
            }

        </section>

    </main>
</div>